export default __webpack_public_path__ + "static/smsc_snow_board-0ed4c80e22cbeccdaad7a804658ebc52.png";